export const demoOwnerReviews = [
  {
    id: 1,
    businessId: 1,
    businessName: "Mangalore Harbour Fish House",
    businessSlug: "mangalore-harbour-fish-house",
    authorName: "Suresh Kini",
    rating: 5,
    comment:
      "The best prawn gassi in Mangalore, full stop. Been coming here for 15 years and the taste never changes.",
    ownerReply:
      "Thank you so much, Suresh! It means the world to us that you've been with us for 15 years. See you soon!",
    repliedAt: "2026-08-12T10:00:00Z",
    flagCount: 0,
    status: "approved",
    reviewedAt: "2026-08-10",
    createdAt: "2026-08-10T09:00:00Z",
  },
  {
    id: 2,
    businessId: 1,
    businessName: "Mangalore Harbour Fish House",
    businessSlug: "mangalore-harbour-fish-house",
    authorName: "Radhika M.",
    rating: 4,
    comment:
      "Excellent fresh fish at reasonable prices. The harbour view makes the experience even better.",
    ownerReply: null,
    repliedAt: null,
    flagCount: 0,
    status: "approved",
    reviewedAt: "2026-07-22",
    createdAt: "2026-07-22T14:30:00Z",
  },
  {
    id: 3,
    businessId: 2,
    businessName: "Harbour Seafood Cloud Kitchen",
    businessSlug: "harbour-seafood-cloud-kitchen",
    authorName: "Vijay Nayak",
    rating: 3,
    comment:
      "Delivery was quick but the curry was a little cold by the time it reached us. Taste was good though.",
    ownerReply: null,
    repliedAt: null,
    flagCount: 0,
    status: "approved",
    reviewedAt: "2026-09-01",
    createdAt: "2026-09-01T20:15:00Z",
  },
  {
    id: 4,
    businessId: 1,
    businessName: "Mangalore Harbour Fish House",
    businessSlug: "mangalore-harbour-fish-house",
    authorName: "Anonymous User",
    rating: 1,
    comment:
      "Terrible terrible place. Go visit my shop instead for cheaper rates. Click the link in my profile for a discount code.",
    ownerReply: null,
    repliedAt: null,
    flagCount: 2,
    status: "pending",
    reviewedAt: "2026-09-12",
    createdAt: "2026-09-12T22:40:00Z",
  },
  {
    id: 5,
    businessId: 2,
    businessName: "Harbour Seafood Cloud Kitchen",
    businessSlug: "harbour-seafood-cloud-kitchen",
    authorName: "Reshma D'Souza",
    rating: 5,
    comment:
      "Ordered for a family gathering and everyone loved it. The fish curry and neer dosa were spot on. Will order again!",
    ownerReply: null,
    repliedAt: null,
    flagCount: 0,
    status: "approved",
    reviewedAt: "2026-09-05",
    createdAt: "2026-09-05T18:20:00Z",
  },
];